<template>
  <q-btn
    :label="actualLabel"
    :ripple="false"
    v-bind="$attrs"
    @click="open"
  />
</template>

<style lang="scss">
@import '~flatpickr/dist/flatpickr.min.css';
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import DateRangePickerMixin from './DateRangePickerMixin';

export default defineComponent({
  mixins: [DateRangePickerMixin],
  props: {
    label: String,
  },
  computed: {
    actualLabel(): string {
      return this.humanValue || this.label;
    },
  },
});
</script>
